import { useHeaderViewWhenScroll } from 'hooks';
import { MainContainer } from './fragments/styled';
import { PopularSection } from './fragments/PopularSection';
import {
  MainSection,
  PopularPlacesSection,
  ClientsFeedbackSection,
} from './fragments';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { popularDestinationsAction } from 'store';
import { Waiting } from './fragments/Waiting';

const Welcome = () => {
  const { isChangeHeaderView } = useHeaderViewWhenScroll();
 
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(popularDestinationsAction.getPopularDestinations());
  }, []);

  return (
    <MainContainer>
      <MainSection isChangeHeaderView={isChangeHeaderView} />

      <PopularPlacesSection />
      {/*//todo open after release*/}
      {/* <HotOffersSection popularDestination={popularDestination} /> */}

      {/*<img className="word" src={Images.world} alt="world" />*/}

      <PopularSection />

      <Waiting />
      <ClientsFeedbackSection />
    </MainContainer>
  );
};

export default Welcome;
